import Icona from 'components/3catinfo/ui/Icona';
import Enllac from 'components/3catinfo/Enllac';
import __isEmpty from 'lodash/isEmpty';
import styles from './destacatHistoric.module.scss';

const DestacatHistoric = (props) => {
    const { item } = props;
    console.log(item);
    const route = {
        type: 'web_3catinfo_eleccions_home',
        slug: item.slug
    };

    return (
        <article>
            <Enllac route={route} dataTestId='destacat-enllac' tabIndex='0' className={styles.enllac}>
                <div className={styles.destacatHistoric}>
                    <Icona className={styles.iconaBg} icona='ic_eleccions' mida='166' isBlanc={true} inline={true} />
                    <div className={styles.wrapperItems}>
                        <h3 className={styles.any}>{item.any}</h3>
                        <div className={styles.wrapperDia}>
                            <span className={styles.dia}>{item.dia}</span>
                            <Icona className={styles.iconaFletxa} icona='fletxa_dreta' mida='24' inline={true} />
                        </div>
                    </div>
                </div>
            </Enllac>
        </article>
    );
};

export default DestacatHistoric;
